"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackhandAbilityHandler = exports.BackhandActorAbilityFactory = exports.BackhandAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const Stun_1 = require("../../core/effects/core/Stun");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class BackhandAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Backhand;
        this.__typeName = "Backhand";
    }
}
exports.BackhandAbilityArgs = BackhandAbilityArgs;
let BackhandActorAbilityFactory = class BackhandActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Backhand", "OneEnemies", 0);
    }
};
BackhandActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Backhand")
], BackhandActorAbilityFactory);
exports.BackhandActorAbilityFactory = BackhandActorAbilityFactory;
let BackhandAbilityHandler = class BackhandAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedEnemy] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 45)
            ],
            onHit(sequence) {
                if ((0, Random_1.randomPercent)() <= 50) {
                    container.applyDebuff({
                        sequence,
                        attackerId: ability.invokerId,
                        targetId: selectedEnemy,
                        duration: Duration_1.Duration.Turns(1),
                        effect: new Stun_1.StunEffectArgs(),
                    });
                }
            }
        });
    }
};
BackhandAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Backhand)
], BackhandAbilityHandler);
exports.BackhandAbilityHandler = BackhandAbilityHandler;
